import { schema } from 'normalizr';

export const suggestedQuotationsSchema = new schema.Entity('suggestedQuotations', {}, { idAttribute: 'suggestedQuotationsId' });




// WEBPACK FOOTER //
// ./src/schemas/suggestedQuotations.js